import { render, staticRenderFns } from "./Vgt2022.vue?vue&type=template&id=2a8d1411&lang=pug&"
import script from "./Vgt2022.vue?vue&type=script&lang=js&"
export * from "./Vgt2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports